// 时间设置
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -43px);">
          <vxe-grid show-overflow height="100%" :stripe="true" border="default" :row-config="{ isHover: true }"
                    ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                    @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button v-if="sfSettleTimeAdd" status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog">新增
                  </vxe-button>
                </div>
                <div class="fr">
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                <vxe-form-item title="所属网点:" field="code">
                  <template v-slot>
                    <el-autocomplete
                      class="inline-input"
                      style="width:11vw ;"
                      v-model="siteName"
                      :fetch-suggestions="querySiteSearch"
                      placeholder=""
                      :trigger-on-focus="false"
                      @select="handleSiteSelect"
                    />
                  </template>
                </vxe-form-item>
                <vxe-form-item title="时间名称:" field="timeName">
                  <template v-slot>
                    <el-input v-model="searchData.timeName" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="时间类型:" field="timeType">
                  <template v-slot>
                    <el-select v-model="searchData.timeType" clearable>
                      <el-option label="全部" :value="null"/>
                      <el-option label="按完工时间" :value="1"/>
                      <el-option label="按网点确认完工时间" :value="2"/>
                      <el-option label="按进入结算池时间" :value="3"/>
                    </el-select>
                  </template>
                </vxe-form-item>

              </vxe-form>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue';
import {tableOption} from '@/const/crud/admin/tenant';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import { mapGetters } from 'vuex';

export default {
  name: 'timeSettings',

  components: {editView, pager},
  data() {
    return {
      total: 0,
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      siteName: null,
      formData: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        siteId: null,
        timeType: null,
        timeName: null,
      },
      searchData: {
        siteId: null,
        timeType: null,
        timeName: null,
      },
      pageSizes: [10, 20, 100],

    };
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    siteName(n) {
      if (!n) {
        this.searchData.siteId = null
      }
    }
  },
  computed:{
      ...mapGetters(["permissions"])
  },
  mounted() {

  },
  created(){
      this.sfSettleTimeAdd = this.permissions["sfSettleTimeAdd"];
  },
  methods: {
    toFilterData() {
            this.searchEvent();
     },
    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.searchData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },


    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 分页功能
    changeTablePage(page, flag) {
      console.log('分页数据', page, this.formData)
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },


    // 搜索
    searchEvent() {
      this.formData.siteId = this.searchData.siteId
      this.formData.timeType = this.searchData.timeType
      this.formData.timeName = this.searchData.timeName

      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },


    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.sfSettleTime.getPageDataUrl,
        param: this.formData,
        method: 'post',
        height: '800px',
        columns: [
          {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
          {title: '时间名称', field: 'timeName', width: 150,},
          {title: '网点名称', field: 'siteName', width: 150,},
          {title: '时间类型', field: 'timeType', width: 150, slots: {
              default: ({row}) => {
                if (row.timeType == 1) {
                  return [
                    <div>
                      <span>按完工时间</span>
                    </div>
                  ];
                } else if (row.timeType == 2) {
                  return [
                    <div>
                      <span>按网点确认完工时间</span>
                    </div>
                  ];
                } else if (row.timeType == 3) {
                  return [
                    <div>
                      <span>按进入结算池时间</span>
                    </div>
                  ];
                }
              }
            }
          },
          {title: '结算开始时间',field: 'beginDate', width: 150},
          {title: '结算结束时间',field: 'endDate', width: 150},
          {field: 'usable', title: '状态', width: 150, slots: {
              default: ({row}) => {
                if (row.usable == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>禁用</span>
                    </div>
                  ];
                } else if (row.usable == 1) {
                  return [
                    <div class="txt-status">
                      <span>启用</span>
                    </div>
                  ];
                }
              }
            }
          },
          {title: '创建人', field: 'createBy', width: 150,},
          {title: '创建时间',field: 'createTime', width: 150},
          {width: 47, fixed: 'right', title: '', sortable: false,
            slots: {
              default: ({row}) => {
                return [
                  <div>
                    <a href="javascript:void(0);" class="a-link"
                       onclick={() => {
                         this.openEditDialog(row.id);
                       }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>
                  </div>
                ];
              }
            }
          }
        ]
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },
  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
